export interface GenAiAssistant {
    id: string;
    name: string;
    businessId: string;
    pageId: string;
    status: number;
    type: AssistantType;
    platform: number;
    accountId: string;
    model: string;
    assistantId: string;
    knowledgeId: string[];
    prompt: string;
    settings: AssistantSettings;
    countRequests?: number;
    countTokens?: number;
    createdById: string;
    createdAt: Date;
}

export enum AssistantType {
    Chatbot = 1,
    ConversationNote = 2,
    PageContent = 3,
}

export enum AiModel {
    GPT35Turbo = 1,
    GPT4 = 2,
    GPT4o = 3,
    GPT4oMini = 4,
    Claude2 = 10,
    Claude3Opus = 11,
    Claude3Sonnet = 12,
    GeminiPro = 20,
    GeminiUltra = 21,
    DeepSeekCoder = 30,
    DeepSeekChat = 31,
}

export interface AssistantSettings {
    temperature: number;
    max_tokens: number;
    history_message: number;
    min_score: number;
    top_k: number;
    tools: {
        nhanhvn: {
            auto_get_info_product: number;
            auto_create_order: number;
        };
    };
    typeSendFirst: number;
    enable_stop_rule: number;
    time_collection_message: number;
}

export interface GenAiAccount {
    id: string;
    name: string;
    platform: AiPlatform;
    status: AccountStatus;
    apiKey: string;
    description: string;
    createdById: string;
    createdAt: Date;
}

export enum AiPlatform {
    OpenAI = 1,
    Claude = 2,
    DeepSeek = 3,
    Gemini = 4,
    Grok = 5,
}

export enum PlatformStatus {
    Active = 'active',
    ComingSoon = 'soon',
}

export const AiPlatformInfo: {
    [key in AiPlatform]: { name: string; avatar: string; status: PlatformStatus };
} = {
    [AiPlatform.OpenAI]: {
        name: 'OpenAI (ChatGPT)',
        avatar: 'assets/img/logo/ai/logo_openai_black.png',
        status: PlatformStatus.Active,
    },
    [AiPlatform.Claude]: {
        name: 'Claude',
        avatar: 'assets/img/logo/ai/logo_claude.png',
        status: PlatformStatus.Active,
    },
    [AiPlatform.Gemini]: {
        name: 'Gemini',
        avatar: 'assets/img/logo/ai/logo_gemini.png',
        status: PlatformStatus.Active,
    },
    [AiPlatform.DeepSeek]: {
        name: 'DeepSeek',
        avatar: 'assets/img/logo/ai/logo_deepseek.png',
        status: PlatformStatus.Active,
    },
    [AiPlatform.Grok]: {
        name: 'Grok',
        avatar: 'assets/img/logo/ai/logo_grok.png',
        status: PlatformStatus.Active,
    },
};

export enum AccountStatus {
    Disabled = 0,
    Enabled = 1,
}
